import FJSceneTextList from './FJSceneTextList';
import useLocalStore from '../../../hooks/useLocalStore';
import { useDispatch, useSelector } from 'react-redux';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import { useCallback } from 'react';
import FJAppConstant from '../../../constants/FJAppConstant';
const FJSceneTextListContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const sceneTextList = useSelector(state => state.textToVideo.sceneTextList);
    const selectTab = useSelector(state => state.textToVideo.selectTab);
    const updateSceneTextList = useCallback(
        (id, options) => {
            dispatch(FJActionTextToVideo.onUpdateSceneTextListAction(id, options));
        },
        [dispatch],
    );
    return (
        <FJSceneTextList
            sceneTextList={sceneTextList}
            updateSceneTextList={updateSceneTextList}
            isShowHeader={selectTab === FJAppConstant.BLOG_URL_TO_VIDEO}
        />
    );
};

export default FJSceneTextListContainer;
